<template>
  <div class="request-card-wrap" @click="toDetail">
    <div class="top-wrap">
      <div>
        <span class="title">{{ instance.name }}</span>
        <span class="types-wrap">{{ instance.tag }}</span>
      </div>
      <span class="icon-wrap">
        <a-icon type="eye" :style="{ color: '#364759' }" />
        <span>{{ instance.browseNum }}</span>
      </span>
    </div>
    <div class="describe">
      <span>{{ instance.user.enpName }}</span>
      <span>需求类型:{{ instance.demandsTypeStr }}</span>
    </div>
    <div class="describe">
      <span>{{ instance.companyTypeStr }}</span>
      <span>发布时间:{{ instance.publishTime }}</span>
    </div>
    <div class="price">
      <span>价格:{{ instance.priceRange === -1 ? '面议' : '￥' + instance.priceRange }}</span>
    </div>
  </div>
</template>

<script>
import { viewDemandInfo } from '@/api/tradingInfos.js'

export default {
  props: {
    instance: Object
  },
  data() {
    return {}
  },
  components: {},
  methods: {
    async toDetail() {
      const { id } = this.instance
      this.$router.push({ name: 'detailDemand', query: { id } })
      await viewDemandInfo(id)
    }
  }
}
</script>
